<app-breadcrumbs></app-breadcrumbs>
<app-modal
  *ngIf="shouldShowCYC()"
  [show]="shouldShowCYC()"
  [cycModal]="true"
  [showBuddy]="false"
  (showChange)="onCoverModalDisplayChange($event)"
>
  <app-confirm-your-cover></app-confirm-your-cover>
</app-modal>
<section class="form-wrapper">
  <div class="form-with-cover">
    <div class="form-container">
      <div class="form-title-container">
        <h1>
          {{ authService.currentUser?.firstName }}
          {{ authService.currentUser?.lastName }}
        </h1>
        <h2>
          {{ pageData.personal_details_heading || 'Personal details' }}
        </h2>
      </div>

      <form [formGroup]="userForm" (ngSubmit)="submitUserForm($event)">
        <div
          *ngIf="authService.currentUser?.registrationMethod === 'EMAIL'"
          class="form-row"
        >
          <div class="form-field">
            <div class="label-container">
              <label for="email">{{
                pageData.email_address || 'Email address'
              }}</label>
              <app-tooltip
                *ngIf="pageData.email_address_tooltip"
                id="email_address_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <input
              formControlName="email"
              type="text"
              name="email"
              id="email"
              [class.error]="
                (userSubmitted() || userControl['email'].dirty) &&
                userControl['email'].errors
              "
            />
            <span
              class="error"
              *ngIf="
                (userSubmitted() || userControl['email'].dirty) &&
                userControl['email'].errors
              "
            >
              <ng-container
                *ngIf="
                  userControl['email'].errors['required'];
                  else invalidEmail
                "
              >
                {{
                  pageData.email_address_empty_error ||
                    'Please enter an email address'
                }}
              </ng-container>
              <ng-template #invalidEmail>
                {{
                  pageData.email_address_invalid_error ||
                    'Please enter a valid email address'
                }}
              </ng-template>
            </span>
          </div>
        </div>

        <input
          type="hidden"
          name="university_id"
          id="university_id"
          formControlName="university_id"
        />

        <a
          *ngIf="isUnihome()"
          class="unihome-link"
          (click)="noLongerAUniHomeCustomer()"
        >
          <h5>{{ getFormattedLink() }}</h5>
        </a>

        <div class="form-row" *ngIf="!isUnihome()">
          <div class="form-field">
            <div class="label-container">
              <label for="university_name">{{
                pageData.university_name || 'University name'
              }}</label>
              <app-tooltip
                *ngIf="pageData.university_name_tooltip"
                id="university_name_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <div class="lookup-wrapper">
              <input
                class="modal-lookup postcode-field-width"
                formControlName="university_name"
                type="text"
                name="university_name"
                id="university_name"
                [class.error]="
                  (userSubmitted() || userControl['university_name'].dirty) &&
                  userControl['university_id'].errors
                "
                (focus)="displayUniLookupModal()"
                (click)="displayUniLookupModal()"
              />
              <a
                href="#"
                class="lookup-list-link"
                id="uni-lll"
                (click)="displayUniListModal($event)"
              >
                List
              </a>
            </div>
            <span
              class="error"
              *ngIf="
                (userSubmitted() || userControl['university_name'].dirty) &&
                userControl['university_id'].errors
              "
            >
              {{
                pageData.university_name_error ||
                  'Please select or enter your University or College'
              }}
            </span>
          </div>
        </div>

        <app-modal
          [show]="showUniLookupModal()"
          (showChange)="showUniLookupModal.set($event)"
          [showBuddy]="true"
          #uniLookupModal
        >
          <h3 class="modal-title">
            {{ pageData.university_name || 'University name' }}
          </h3>
          <app-uni-lookup
             (closeSelf)="hideUniSelectionModals()"
             (uniSelected)="universitySelected($event)"
             (addUni)="changeShowAddUniModal($event)"
             (alternativeUni)="handleNotAtUni()"
             [noUnisFoundMessage]="
               pageData.no_unis_found_message ||
               'No Universities found containing'
             "
            [searchTerm]="uniLookupSearchTerm()"
             #uniLookup
           ></app-uni-lookup>
         </app-modal>

         <app-modal
          [show]="showUniListModal()"
          (showChange)="showUniListModal.set($event)"
           [showBuddy]="true"
           #uniListModal
         >
          <h3 class="modal-title">
            {{
              pageData.list_modal_title || 'Choose your University or College'
            }}
          </h3>
          <app-uni-list
            (uniSelected)="universitySelected($event)"
            (alternativeUni)="handleNotAtUni()"
            (addUni)="changeShowAddUniModal($event)"
            [noUnisFoundForLetterMessage]="
              pageData.no_unis_found_with_that_letter_message ||
              'No Universities or Colleges could be found with that letter. Please add your University/College.'
            "
          ></app-uni-list>
        </app-modal>

        <app-modal [show]="showUniAddModal()" (showChange)="showUniAddModal.set($event)" [showBuddy]="true" #uniAddModal>
              <h3 class="modal-title">Add your University or College</h3>
              <app-uni-add
                (uniAdded)="universityEntered($event)"
                [prefill]="addUniPrefill()"
                #uniAdd
              ></app-uni-add>
        </app-modal>

        <input
          type="hidden"
          name="residence_id"
          id="residence_id"
          formControlName="residence_id"
        />

        <div class="form-row" *ngIf="!isUnihome()">
          <div class="form-field">
            <div class="label-container">
              <label for="residence_name">{{
                accommodationStayingText() ||
                  'Where are you staying whilst at university?'
              }}</label>
              <app-tooltip
                *ngIf="pageData.staying_tooltip && !isPathwayProvider()"
                id="staying_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <p>{{ pageData.staying_info_copy }}</p>
            <div class="lookup-wrapper">
              <input
                class="modal-lookup"
                formControlName="residence_name"
                type="text"
                name="residence_name"
                id="residence_name"
                [class.error]="
                  (userSubmitted() || userControl['residence_name'].dirty) &&
                  userControl['residence_id'].errors
                "
                (focus)="displayResidenceLookupModal()"
                (click)="displayResidenceLookupModal()"
              />
              <a
                href="#"
                class="lookup-list-link"
                id="residence-lll"
                (click)="displayResidenceListModal($event)"
                >List</a
              >
            </div>
            <span
              class="error"
              *ngIf="
                (userSubmitted() || userControl['residence_name'].dirty) &&
                userControl['residence_id'].errors
              "
            >
              {{
                pageData.staying_error ||
                  'Please select or enter your accommodation whilst at University'
              }}
            </span>
          </div>
        </div>

        <!-- Accommodation List search -->
        <app-modal
          [show]="showResidenceLookupModal()"
          (showChange)="showResidenceLookupModal.set($event)"
          [showBuddy]="true"
          #residenceLookupModal
        >
          <h3 class="modal-title">
            {{
              accommodationStayingText() ||
                'Where are you staying whilst at university?'
            }}
          </h3>
          <p>{{ pageData.staying_info_copy }}</p>
          <app-residence-lookup
            (closeSelf)="hideResidenceSelectionModals()"
            (residenceSelected)="residenceSelected($event)"
            (alternateResidence)="handleAlternateResidence($event)"
            [noResidencesFoundMessage]="
              pageData.no_accommodations_found_message ||
              'No accommodations found containing'
            "
            [searchTerm]="residenceLookupSearchTerm()"
             #residenceLookup
           ></app-residence-lookup>
         </app-modal>

         <!-- Accommodation Manual search  -->
         <app-modal
          [show]="showResidenceListModal()"
          (showChange)="showResidenceListModal.set($event)"
           [showBuddy]="true"
           #residenceListModal
         >
          <h3 class="modal-title">
            {{
              accommodationStayingText() ||
                'Where are you staying whilst at university?'
            }}
          </h3>
          <p>{{ pageData.staying_info_copy }}</p>
          <app-residence-list
            (residenceSelected)="residenceSelected($event)"
            (alternateResidence)="handleAlternateResidence($event)"
            [noResidencesFoundForLetterMessage]="
              pageData.no_accommodations_found_with_that_letter_message ||
              'No accommodations found for that letter group'
            "
          ></app-residence-list>
        </app-modal>

        <div class="form-row" *ngIf="isUnihome()">
          <div class="form-field">
            <div class="label-container">
              <label for="postcode">{{
                this.pageData.postcode_name ??
                  'Enter postcode of where you are staying'
              }}</label>
              <app-tooltip
                *ngIf="pageData.postcode_name_tooltip"
                id="postcode_name_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <!-- setting autocomplete value stops field autocompleting -->
            <input
              class="modal-lookup postcode-width"
              formControlName="postcode"
              type="text"
              name="postcode"
              id="postcode"
              autocomplete="postcode"
              [class.error]="
                (userSubmitted() || userControl['postcode'].dirty) &&
                userControl['postcode'].errors
              "
            />
            <span
              class="error"
              *ngIf="
                 isUnihome() &&
                (userSubmitted() || userControl['postcode'].dirty) &&
                userControl['postcode'].errors
              "
            >
              <ng-container
                *ngIf="
                  userControl['postcode'].errors['required'];
                  else invalidPostcode
                "
              >
                Please enter a valid postcode
              </ng-container>
              <ng-template #invalidPostcode>
                Invalid postcode entered
              </ng-template>
            </span>
          </div>
        </div>

        <div class="error-block-container">
          <app-error-block *ngIf="userError()">
            {{
              pageData.user_error_message ||
                'There was a problem updating your details. Please contact us if you require assistance.'
            }}
          </app-error-block>
          <app-success-block *ngIf="userSuccess()">
            {{
              pageData.user_success_message || 'Your details have been updated'
            }}
          </app-success-block>
        </div>

        <button type="submit">Save changes</button>
      </form>

      <h2
        *ngIf="authService.currentUser?.registrationMethod === 'EMAIL'"
        class="password-section-header"
      >
        {{ pageData.change_password_heading }}
      </h2>
      <form
        *ngIf="authService.currentUser?.registrationMethod === 'EMAIL'"
        [formGroup]="passwordForm"
        (ngSubmit)="submitPasswordForm($event)"
      >
        <div class="form-row">
          <div class="form-field">
            <div class="label-container">
              <label for="password">Old password</label>
              <app-tooltip
                *ngIf="pageData.old_password_tooltip"
                id="old_password_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <input
              formControlName="old_password"
              type="password"
              name="old_password"
              id="old_password"
              [class.error]="
                (passwordSubmitted() || passwordControl['old_password'].dirty) &&
                passwordControl['old_password'].errors
              "
            />
            <span
              class="error"
              *ngIf="
                (passwordSubmitted() || passwordControl['old_password'].dirty) &&
                passwordControl['old_password'].errors
              "
            >
              {{
                pageData.old_password_error ||
                  'Please enter your current password'
              }}
            </span>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field">
            <div class="label-container">
              <label for="new_password">New password</label>
              <app-tooltip
                *ngIf="pageData.new_password_tooltip"
                id="new_password_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <input
              formControlName="new_password"
              type="password"
              name="new_password"
              id="new_password"
              [class.error]="
                (passwordSubmitted() || passwordControl['new_password'].dirty) &&
                passwordControl['new_password'].errors
              "
            />
            <span
              class="error"
              *ngIf="
                (passwordSubmitted() || passwordControl['new_password'].dirty) &&
                passwordControl['new_password'].errors
              "
            >
              <ng-container
                *ngIf="
                  passwordControl['new_password'].errors['required'];
                  else invalidPassword
                "
              >
                {{
                  pageData.new_password_empty_error ||
                    'Please enter a new password'
                }}
              </ng-container>
              <ng-template #invalidPassword>
                {{
                  pageData.new_password_invalid_error ||
                    'Passwords must be at least 8 characters long and contain at least one uppercase letter and one number'
                }}
              </ng-template>
            </span>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field">
            <div class="label-container">
              <label for="confirm_new_password">Confirm new password</label>
              <app-tooltip
                *ngIf="pageData.confirm_new_password_tooltip"
                id="confirm_new_password_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <input
              formControlName="confirm_new_password"
              type="password"
              name="confirm_new_password"
              id="confirm_new_password"
              [class.error]="
                (passwordSubmitted() ||
                  passwordControl['confirm_new_password'].dirty) &&
                passwordControl['confirm_new_password'].errors
              "
            />
            <span
              class="error"
              *ngIf="
                (passwordSubmitted() ||
                  passwordControl['confirm_new_password'].dirty) &&
                passwordControl['confirm_new_password'].errors
              "
            >
              <ng-container
                *ngIf="
                  passwordControl['confirm_new_password'].errors['required'];
                  else invalidConfirmPassword
                "
              >
                {{
                  pageData.confirm_new_password_empty_error ||
                    'Please confirm your new password'
                }}
              </ng-container>
              <ng-template #invalidConfirmPassword>
                {{
                  pageData.confirm_new_password_match_error ||
                    'Passwords must match'
                }}
              </ng-template>
            </span>
          </div>
        </div>

        <div class="error-block-container">
          <app-error-block *ngIf="passwordError()">
            {{
              pageData.password_error_message ||
                'There was a problem updating your password:'
            }}
            {{ passwordErrorMessage() }}
          </app-error-block>
          <app-success-block *ngIf="passwordSuccess()">
            {{
              pageData.password_success_message ||
                'Your password was successfully updated'
            }}
          </app-success-block>
        </div>

        <button type="submit">Update password</button>
      </form>
    </div>

    <div class="cover-container" *ngIf="pageData?.cover_image">
      <img
        [src]="pageData.cover_image.data.attributes.url"
        alt="Registration Cover Image"
      />
    </div>
  </div>
</section>

<app-modal [show]="showConfirm()" (showChange)="confirmModalClosed()">
  <div>
    <h2>{{ pageData.confirm_modal_heading || 'Confirm your changes' }}</h2>
    <p>
      {{
        pageData.confirm_modal_text ||
          'Please note: Updating your details will only update your Howden for Students account. If you have purchased insurance from one of our partners, please contact them directly to update your details.'
      }}
    </p>
    <button [class.button-loading]="doingChanges()" (click)="doConfirm()">
      <span>{{ pageData.confirm_modal_button || 'Confirm changes' }}</span>
    </button>
  </div>
</app-modal>

<app-modal [show]="showUserUpdateChoice()" (showChange)="showUserUpdateChoice.set($event)">
  <app-user-update-choice
    [choice]="'no-longer-customer'"
    (updateDetails)="handleNoLongerACustomerChoice($event)"
  ></app-user-update-choice>
</app-modal>

<app-modal [show]="showUpdateUserFromUnihomes()" [showBuddy]="false" (showChange)="showUpdateUserFromUnihomes.set($event)">
  <app-update-uni-accommodation-unihomes
    (updateComplete)="unihomeUpdateComplete($event)"
  ></app-update-uni-accommodation-unihomes>
</app-modal>

<app-modal [show]="showTooltipModal()" [showBuddy]="false" (showChange)="showTooltipModal.set($event)">
  <app-tooltip-modal [content]="tooltipModalContent()"></app-tooltip-modal>
</app-modal>
